/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GenerateScenarioCodeForShipmentResponse
 */
export interface GenerateScenarioCodeForShipmentResponse {
  /**
   *
   * @type {string}
   * @memberof GenerateScenarioCodeForShipmentResponse
   */
  scenario: string;
}

/**
 * Check if a given object implements the GenerateScenarioCodeForShipmentResponse interface.
 */
export function instanceOfGenerateScenarioCodeForShipmentResponse(
  value: object,
): value is GenerateScenarioCodeForShipmentResponse {
  if (!("scenario" in value) || value["scenario"] === undefined) return false;
  return true;
}

export function GenerateScenarioCodeForShipmentResponseFromJSON(
  json: any,
): GenerateScenarioCodeForShipmentResponse {
  return GenerateScenarioCodeForShipmentResponseFromJSONTyped(json, false);
}

export function GenerateScenarioCodeForShipmentResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GenerateScenarioCodeForShipmentResponse {
  if (json == null) {
    return json;
  }
  return {
    scenario: json["scenario"],
  };
}

export function GenerateScenarioCodeForShipmentResponseToJSON(
  json: any,
): GenerateScenarioCodeForShipmentResponse {
  return GenerateScenarioCodeForShipmentResponseToJSONTyped(json, false);
}

export function GenerateScenarioCodeForShipmentResponseToJSONTyped(
  value?: GenerateScenarioCodeForShipmentResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    scenario: value["scenario"],
  };
}
